import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

class MostAccessedTableMobile extends Component {
  state = {}

  renderHeaders = (lsMenus) => {
    const { translate } = this.props
    const keysSorted = Object.keys(lsMenus).sort((a, b) =>
      lsMenus[a].dsMenuTranslated > lsMenus[b].dsMenuTranslated ? 1 : -1
    )
    const menuHeaders = keysSorted.map((key, i) => {
      let formattedCodMenu = ''
      if (lsMenus[key].dsMenuTranslated.startsWith('%%')) {
        formattedCodMenu = translate(lsMenus[key].dsMenu)
      } else {
        formattedCodMenu = lsMenus[key].dsMenuTranslated
      }
      return (
        <th key={i} className='align-center hidden-column overflow-hidden-column'>{`${translate(
          formattedCodMenu
        )}`}</th>
      )
    })
    return (
      <tr>
        <th className='align-left hidden-column overflow-hidden-column'>
          &nbsp;
        </th>
        {menuHeaders}
      </tr>
    )
  }

  renderRows = (lsMenus, lsBranches, lsAccesses) => {
    const keysSorted = Object.keys(lsMenus).sort((a, b) =>
      lsMenus[a].dsMenuTranslated > lsMenus[b].dsMenuTranslated ? 1 : -1
    )

    const branchLines = Object.keys(lsBranches).map((keyBranch, i) => {
      const menuColumns = keysSorted.map((keyMenu, i) => {
        const itemArray = lsAccesses.filter(
          (i) =>
            parseInt(i.idBranch, 10) === parseInt(keyBranch, 10) &&
            i.cdMenu === parseInt(keyMenu, 10)
        )

        let count
        if (itemArray.length > 0) {
          count = itemArray[0].count
        } else {
          count = 0
        }

        return <td key={i} className='align-center'>{count}</td>
      })

      return (
        <tr key={i}>
          <td className='strong'>
            {`${keyBranch} - ${lsBranches[keyBranch]}`}
          </td>
          {menuColumns}
        </tr>
      )
    })

    return <tbody>{branchLines}</tbody>
  }

  render() {
    const { accesses, translate, fetchReports } = this.props

    return (
      <div className='MostAccessedTable'>
        <Row>
          <Col xs={11}>
            <legend>{translate('analytics.most-accessed-reports')}</legend>
          </Col>
          <Col xs={1}>
            <legend onClick={fetchReports} style={{ cursor: 'pointer' }}>
              {translate('option.btn.export')}
            </legend>
          </Col>
        </Row>

        <Col xs={12} className='sticky-headers-table-container'>
          <table className='sticky-headers-table table-zebra margin-top'>
            <thead>
              {accesses &&
                accesses.lsBranches &&
                this.renderHeaders(accesses.lsMenus)}
            </thead>
            {accesses &&
              accesses.lsMenus &&
              this.renderRows(
                accesses.lsMenus,
                accesses.lsBranches,
                accesses.lsAccesses
              )}
          </table>
        </Col>
      </div>
    )
  }
}

MostAccessedTableMobile.propTypes = {
  accesses: PropTypes.object,
  translate: PropTypes.func.isRequired,
  fetchReports: PropTypes.func.isRequired,
}

export default MostAccessedTableMobile
